import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Save } from 'lucide-react';
import { toast } from 'sonner';

const toText = (arr) => (arr || []).join('\n');
const fromText = (t) => t.split('\n').map((x) => x.trim()).filter(Boolean);

export default function SetariView({ api, settings, isBroker, onSaved }) {
  const [s, setS] = useState(settings || {});
  const [saving, setSaving] = useState(false);
  useEffect(() => { setS(settings || {}); }, [settings]);

  const save = async () => {
    setSaving(true);
    try {
      await api.put('/settings', s);
      toast.success('Setări salvate');
      onSaved && onSaved();
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Eroare la salvare');
    } finally {
      setSaving(false);
    }
  };

  if (!isBroker) {
    return <p className="text-sm text-gray-500" data-testid="crm-setari-readonly">Doar brokerul firmei poate edita setările CRM.</p>;
  }

  const listField = (key, label) => (
    <div>
      <Label className="text-xs">{label} (câte unul pe linie)</Label>
      <textarea className="w-full border rounded-md p-2 text-sm" rows={6}
        value={toText(s[key])} onChange={(e) => setS({ ...s, [key]: fromText(e.target.value) })}
        data-testid={`crm-setari-${key}`} />
    </div>
  );

  const motivField = (stage, label) => (
    <div>
      <Label className="text-xs">Motive renunțare — {label}</Label>
      <textarea className="w-full border rounded-md p-2 text-sm" rows={4}
        value={toText(s.motive?.[stage])}
        onChange={(e) => setS({ ...s, motive: { ...(s.motive || {}), [stage]: fromText(e.target.value) } })}
        data-testid={`crm-setari-motive-${stage}`} />
    </div>
  );

  return (
    <div data-testid="crm-setari" className="space-y-4">
      <Card>
        <CardHeader><CardTitle className="text-base">Liste editabile</CardTitle></CardHeader>
        <CardContent className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {listField('surse', 'Surse')}
          {listField('banci', 'Bănci')}
          {listField('tipuriCredit', 'Tipuri de credit')}
          {listField('tipuriDocumente', 'Tipuri de documente')}
        </CardContent>
      </Card>
      <Card>
        <CardHeader><CardTitle className="text-base">Motive de renunțare (pe etape)</CardTitle></CardHeader>
        <CardContent className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {motivField('1', 'Etapa 1 – Lead')}
          {motivField('2', 'Etapa 2 – Client')}
          {motivField('3', 'Etapa 3 – Dosar')}
          {motivField('4', 'Etapa 4 – Retenție')}
        </CardContent>
      </Card>
      <Card>
        <CardHeader><CardTitle className="text-base">Acces administrator</CardTitle></CardHeader>
        <CardContent>
          <label className="flex items-center gap-2 text-sm">
            <input type="checkbox" checked={!!s.adminAccess}
              onChange={(e) => setS({ ...s, adminAccess: e.target.checked })}
              data-testid="crm-setari-admin-access" />
            Permite administratorului Finbro să vadă clienții firmei mele (consimțământ GDPR)
          </label>
        </CardContent>
      </Card>
      <Button onClick={save} disabled={saving} data-testid="crm-setari-save">
        <Save className="h-4 w-4 mr-1" /> {saving ? 'Se salvează…' : 'Salvează setările'}
      </Button>
    </div>
  );
}
